module.exports = __webpack_public_path__ + "static/cart09-76dd2cfbe2b5e58fc8d9b73ddc2802da.svg";